import { useOutletContext } from 'react-router-dom'

import type { MyTrainingsTrainingFragment } from 'generated/resources/graphql'

export const useTrainingsContext = () =>
  useOutletContext<{ trainings: MyTrainingsTrainingFragment[] }>()
